"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueFromDictionary = exports.createTableSubDictionaries = void 0;
const createTableSubDictionaries = (dictionary) => {
    return {
        mobileFilterDictionary: {
            applyBtnLabel: dictionary.applyBtnLabel,
            cancelBtnLabel: dictionary.cancelBtnLabel,
            closeBtnLabel: dictionary.closeBtnLabel,
            doneBtnLabel: dictionary.doneBtnLabel,
            filterHeaderDefaultLabel: dictionary.filterHeaderDefaultLabel,
            resetBtnLabel: dictionary.resetBtnLabel,
        },
        mobileControlPanelDictionary: {
            searchInputAriaLabel: dictionary.search,
            filterBtnLabel: dictionary.filterBtnLabel,
            resetFilterLabel: dictionary.resetFilterLabel,
        },
        tableBodyDictionary: {
            download: dictionary.download,
            validFor: dictionary.validFor,
            globalTooltipMessage: dictionary.globalTooltipMessage,
            multipleTooltipMessage: dictionary.multipleTooltipMessage,
            updated: dictionary.updated,
            fileType: dictionary.fileType,
            type: dictionary.type,
            status: dictionary.status,
            languages: dictionary.languages,
            multilanguageLabel: dictionary.multilanguageLabel,
            expandRow: dictionary.expandRow,
            collapseRow: dictionary.collapseRow,
        },
        accessibilitySortingDictionary: {
            ascendingSortAriaLabel: dictionary.ascendingSortAriaLabel,
            descendingSortAriaLabel: dictionary.descendingSortAriaLabel,
            notSortedAriaLabel: dictionary.notSortedAriaLabel,
        },
    };
};
exports.createTableSubDictionaries = createTableSubDictionaries;
const getValueFromDictionary = (dictionary, key) => {
    return dictionary[key] ? dictionary[key] : '';
};
exports.getValueFromDictionary = getValueFromDictionary;
